import { render, staticRenderFns } from "./ShippingPreference.vue?vue&type=template&id=f2835606&scoped=true&"
import script from "./ShippingPreference.vue?vue&type=script&lang=js&"
export * from "./ShippingPreference.vue?vue&type=script&lang=js&"
import style0 from "./ShippingPreference.vue?vue&type=style&index=0&id=f2835606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2835606",
  null
  
)

export default component.exports